import React, { memo } from 'react';
import { TextField, InputLabel, TextFieldProps } from '@material-ui/core';
import { FieldMetaState } from 'react-final-form';
import { formStyles } from './styles';
import { InputFieldProps, FormValue } from './utils';
import InputFieldWrapper from './InputFieldWrapper';

type InputProps = TextFieldProps & {
  field: InputFieldProps;
  meta: FieldMetaState<FormValue>;
  wrapField?: boolean;
};

const Input = ({ field, meta, wrapField = true, ...props }: InputProps) => {
  const classes = formStyles();

  const hasValidationError = Boolean(
    meta.error && (meta.touched || meta.submitFailed)
  );
  const showError = hasValidationError || Boolean(field.hasError);
  const helperText = hasValidationError ? meta.error : field.helperText;
  const fieldId = field.id || field.name;

  if (wrapField) {
    return (
      <InputFieldWrapper>
        <InputLabel htmlFor={fieldId}>{field.label}</InputLabel>
        <TextField
          size="small"
          error={showError}
          {...props}
          name={field.name}
          id={fieldId}
          data-qa-id={field.qaId}
          variant="outlined"
          fullWidth
          InputLabelProps={{ shrink: false }}
          inputProps={field.inputProps}
          data-testid={field.qaId}
          className={field.className || classes.field}
          helperText={helperText}
        />
      </InputFieldWrapper>
    );
  }
  return (
    <>
      <InputLabel htmlFor={fieldId}>{field.label}</InputLabel>
      <TextField
        size="small"
        error={showError}
        {...props}
        name={field.name}
        id={fieldId}
        data-qa-id={field.qaId}
        variant="outlined"
        fullWidth
        InputLabelProps={{ shrink: false }}
        inputProps={{ ...props.inputProps, ...field.inputProps }}
        data-testid={field.qaId}
        className={field.className || classes.field}
        helperText={helperText}
      />
    </>
  );
};

export default memo(Input);
